import { useState, createContext, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Job from "./pages/Job";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Cooperation from "./pages/Cooperation";
import Slask from "./pages/Slask";
import Faq from "./pages/FAQ";
import Zip from "./pages/Zip";
import { IntlProvider } from "react-intl";
import messages from "./translate/Messages";
//import { Container } from "react-bootstrap";
import NotFound from "./components/NotFound";
import Menu from "./components/Menu";
import MenuOffcanvas from "./components/MenuOffcanvas";
import Footer from "./components/Footer";
import styled from "styled-components";
import "bootstrap/dist/css/bootstrap.min.css";

export const LangContext = createContext();
export const CanvasContext = createContext();
export const API_URL = "https//michaljaskulski.pl/api";
export const CheckIconSpace = "&nbsp;&nbsp;";
export const iconSize = { fontSize: 50 };

const PageWrapper = styled.div`
  background: #f5f5f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const App = () => {
  const [language, setLanguage] = useState("pl");
  const [isOpenCanvas, setIsOpenCanvas] = useState(false);
  const [pickedLang, setPickedLang] = useState("pl");
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const updateSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    setLanguage(pickedLang);
  }, [pickedLang, language]);

  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <header>
        <LangContext.Provider value={language}>
          <CanvasContext.Provider value={!isOpenCanvas}>
            <nav className="navbar">
              {windowSize.width < 1300 && (
                <span onClick={() => setIsOpenCanvas(!isOpenCanvas)}>
                  <MenuOffcanvas
                    isOpen={isOpenCanvas}
                    changeData={(picked) => setPickedLang(picked)}
                  />
                </span>
              )}
              <Menu
                isOpen={isOpenCanvas}
                changeData={(picked) => setPickedLang(picked)}
              />
            </nav>
          </CanvasContext.Provider>
        </LangContext.Provider>
      </header>
      <PageWrapper>
        <LangContext.Provider value={language}>
          <main>
            <Routes>
              <Route path="/" element={<Navigate to="/home" />} />
              <Route path="/home" element={<Home />} />
              <Route path="/react-developer" element={<Services />} />
              <Route path="/tworzenie-aplikacji-webowych" element={<Job />} />
              <Route path="/projekty-react" element={<Projects />} />
              <Route path="/fullstack-developer-slask" element={<Slask />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/wspolpraca" element={<Cooperation />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/zip" element={<Zip />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </LangContext.Provider>
      </PageWrapper>
      <Footer />
    </IntlProvider>
  );
};

const AppWrapper = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

export default AppWrapper;
